import { createAction, props } from '@ngrx/store';
import { RelationshipDesignationTypes } from '@shared/models/relationship-designation-types';

import { Person } from '../../reducers/beneficiaries/beneficiaries.reducer';

export const UpdateRelationshipDesignation = createAction(
  '[Beneficiaries] Update Relationship Designation',
  props<{ payload: RelationshipDesignationTypes }>(),
);

export const UpdateOnlyChild = createAction(
  '[Beneficiaries] Update Only Child',
  props<{ payload: boolean }>(),
);

export const UpdateOtherBene = createAction(
  '[Beneficiaries] Update Beneficiary Information',
  props<{ payload: Person[] }>(),
);
